import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls the window to the top
 * when the route changes. This component uses multiple attempts at different intervals
 * to ensure reliable scrolling behavior across various scenarios and browser implementations.
 * 
 * This component should be used near the top of the app component tree,
 * typically right inside the Router component.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll
    window.scrollTo(0, 0);
    
    // Create an array of timeouts for multiple scroll attempts
    const timeoutIds = [
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), 100),
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), 300),
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), 500)
    ];
    
    // Clean up all timeouts on unmount
    return () => {
      timeoutIds.forEach(id => clearTimeout(id));
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop; 